export function push(map, item) {
    map.set(map.size, item);
}
